<template>
    <div class="about-us-content">
        <el-affix :z-index="maxZIndex">
            <NavBar></NavBar>
        </el-affix>

        <div class="main">

            <Breadcrumb :bread-list="breadList"></Breadcrumb>

            <!-- <div class="h-title">
                关于我们
            </div> -->
            <div class="article-content">
                <div class="title">
                    {{ $t('aboutUs.articleTitle') }}
                </div>

                <template v-for="(item, index) in ($tm('aboutUs.articleContentList') as any)" :key="index">
                    <div class="h2-title">
                        {{ item.h2Title }}
                    </div>

                    <div class="introduce">
                        <p v-for="(p, pIndex) in item.introduce" :key="pIndex">
                            {{ p }}
                        </p>
                    </div>
                </template>

                <div class="advantage-content">
                    <div class="advantage-item" v-for="(item, index) in ($tm('index.advantage') as any)" :key="index">
                        <div class="top">
                            {{ item.top }}
                        </div>
                        <div class="bottom">
                            {{ item.bottom }}
                        </div>
                    </div>
                </div>

                <div class="img">
                    <el-image :src="companyImage" fit="contain" style="max-height: 500px;" />
                </div>

                <el-row :align="'middle'" v-for="(item,index) in ($tm('aboutUs.illustration') as any)" :gutter="20">
                    <template v-if="index % 2 === 0">
                        <el-col :span="12">
                            <div class="text">
                                {{ item.tips }}
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="img">
                                <el-image :src="item.image" fit="contain" style="max-height: 500px;" />
                            </div>
                        </el-col>
                    </template>

                    <template v-else>
                        <el-col :span="12">
                            <div class="img">
                                <el-image :src="item.image" fit="contain" style="max-height: 500px;" />
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="text">
                                {{ item.tips }}
                            </div>
                        </el-col>
                    </template>
                </el-row>
            </div>
        </div>

        <Footer></Footer>
    </div>
</template>

<script setup lang="ts">
import NavBar from '@/components/NavBar.vue';
import Footer from '@/components/Footer.vue';
import { UtilMethods } from '@/util/UtilMethods';
import { useI18n } from 'vue-i18n';
import { BreadType, LanguagePackageType } from '@/typeDefine/EntityType';
import { LanguageType } from '@/typeDefine/CommonTypes';
import Breadcrumb from '@/components/Breadcrumb.vue';
import companyImage from '@/assets/images/companyImage.png'

const { t } = useI18n<[LanguagePackageType], LanguageType>()

const maxZIndex: string = UtilMethods.getDOMStyleFromCSS('--max-z-index')

//面包屑地址
const breadList: BreadType[] = [
    {
        text: 'index.navBar.aboutUs'
    }
]
</script>

<style lang="css" scoped>
.about-us-content .main {
    width: 90%;
    margin: 0 auto;
}

.about-us-content .h-title {
    font-size: 48px;
    margin-bottom: 30px;
}

.about-us-content .article-content {
    margin: 30px 0;
}

.about-us-content .article-content .title {
    font-size: 30px;
    color: var(--primary-color);
    font-weight: bold;
    text-align: center;
    margin-bottom: 20px;
}

.about-us-content .article-content .h2-title {
    font-size: 24px;
    color: #555;
}

.about-us-content .article-content .introduce p,
.about-us-content .article-content .introduce p {
    text-indent: 2em;
    line-height: 30px;
}

.about-us-content .advantage-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 80%;
    margin: 50px auto;
}

.about-us-content .advantage-content .advantage-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100px;
}

.about-us-content .advantage-content .advantage-item .top {
    font-size: 36px;
    color: var(--primary-color);
    font-weight: bold;
}

.about-us-content .advantage-content .advantage-item .bottom {
    color: #666;
    font-size: 18px;
}

.about-us-content .article-content .img {
    width: 100%;
    max-height: 500px;
    margin-bottom: 50px;
}

.about-us-content .article-content .img .el-image {
    display: block;
}


::v-deep .img .el-image__inner {
    display: block;
    max-height: 500px !important;
}

@media (max-width: 1200px) {
    .about-us-content .advantage-content {
        flex-wrap: wrap;
    }

    .about-us-content .advantage-content .advantage-item {
        width: calc(100% / 2);
    }
}

@media (max-width: 768px) {
    .about-us-content .advantage-content .advantage-item {
        width: 100%;
    }
}
</style>